// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import { PlasmicTopNav } from "./plasmic/o_21_p_nexus_2_4_1_prod/PlasmicTopNav";

function TopNav_(props, ref) {
  // Use PlasmicTopNav to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicTopNav are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all TopNavProps here, but feel free
  // to do whatever works for you.
  return <PlasmicTopNav topnav={{ ref }} {...props} />;
}

const TopNav = React.forwardRef(TopNav_);

export default TopNav;
